import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const loadRecaptcha = successCallback => {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?render=${StringConstantsMixin.constants.GOOGLE_RECAPTCHA.SITE_KEY}`;
  script.async = true;
  script.onload = () => {
    grecaptcha.ready(() => {
      successCallback(grecaptcha);
    });
  };
  document.body.appendChild(script);
};

const executeRecaptcha = (recaptchaObject, action) => {
  return recaptchaObject.execute(StringConstantsMixin.constants.GOOGLE_RECAPTCHA.SITE_KEY, { action });
};

const loadAndExecuteRecaptcha = (action, successCallback) => {
  loadRecaptcha(recaptchaObject =>
    executeRecaptcha(recaptchaObject, action)
      .then(successCallback)
      .catch(err => console.error('RECAPTCHA ERROR', err))
  );
};

export { loadRecaptcha, executeRecaptcha, loadAndExecuteRecaptcha };
